import { render, staticRenderFns } from "./not-fount.vue?vue&type=template&id=54f47e5c&scoped=true&keep-alive=true&"
import script from "./not-fount.vue?vue&type=script&lang=js&"
export * from "./not-fount.vue?vue&type=script&lang=js&"
import style0 from "./not-fount.vue?vue&type=style&index=0&id=54f47e5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f47e5c",
  null
  
)

export default component.exports